import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const updatePayrollOrderMutation = gql`
  mutation UpdatePayrollOrder(
    $order_id: String!
    $apply_updates_to_employee_profile: Boolean
    $national_minimum_wage_check_complete: Boolean
    $basic_details_check_complete: Boolean
    $order_details_check_complete: Boolean
    $ni_number: String
    $employee_number: String
  ) {
    updatePayrollOrder(
      order_id: $order_id
      apply_updates_to_employee_profile: $apply_updates_to_employee_profile
      national_minimum_wage_check_complete: $national_minimum_wage_check_complete
      basic_details_check_complete: $basic_details_check_complete
      order_details_check_complete: $order_details_check_complete
      ni_number: $ni_number
      employee_number: $employee_number
    )
  }
`

export const updatePayrollOrderKey = getQueryNames(updatePayrollOrderMutation)[0]
